<label for="googleServicesJson">
    <i class="upload-icon fa-solid fa-upload"></i>
    <input (change)="onGoogleServicesUpload($event)" type="file" id="googleServicesJson" style="display: none">
</label>
